import Book from './Book'
import type { BookProps } from './Book.types'

export default Book

export type { BookProps }
